import { TaskDocConfirmRequest } from './interface/front-line-doc-confirm.request';
import { deepCopy, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { Table } from 'primeng/table';
import { BookingService } from '../../services/booking.service';
import { FrontlineDocumentService } from './../../../../core/services/frontline-document.service';
import { LaasOption } from './../../../../core/models/laas-option';
import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { FileCategory } from 'src/app/core/constants/file-category.constant';
import { DateTableColumn } from 'src/app/core/models/date-table-column';
import { PageInfo } from 'src/app/core/models/page-info';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { FileManagementComponent } from '../file-management/file-management.component';
import { SearchTaskDocDetailResponse } from './interface/search-front-doc-detail-response';
import { SearchTaskDocHeaderResponse } from './interface/search-frontline-doc-header-response';
import { TaskListOptions } from 'src/app/core/models/options/task-list-options';
import { CodeConverter } from 'server/entity/code-converter';
import { DeliveryOrderService } from '../../services/delivery-order.service';
import { TaskDocChangeTaskRequest } from './interface/front-line-doc-change-task-reuqest';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { forkJoin, take } from 'rxjs';
import { SearchTaskDocHeaderRequest } from './interface/search-frontline-doc-header-request';
import { FrontlineDocomentReturnConfirmDialogComponent } from '../frontline-docoment-return-confirm-dialog/frontline-docoment-return-confirm-dialog.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FrontLineDocReturnRequest } from './interface/front-line-doc-return-request';
import { FrontLineDocReturnConfirmRequest } from './interface/front-line-doc-return-confirm-request';

@Component({
  selector: 'laas-task-document',
  templateUrl: './frontline-document.component.html',
  styleUrls: ['./frontline-document.component.scss'],
})
export class FrontlineDocumentComponent
  extends SessionBaseComponent
  implements OnInit
{
  @Input() fileCategory!: FileCategory;
  @Input() referenceKeys!: string[];
  @Input() uploadFileType!: string;
  @Input() callingFunction: string | null | undefined;

  @ViewChild('fileManagement') fileManagement!: FileManagementComponent;
  @ViewChild('headerTable') headerTable!: Table;
  @ViewChild('applyDialog') applyDialog!: FrontlineDocomentReturnConfirmDialogComponent;
  @ViewChild('replyDialog') replyDialog!: FrontlineDocomentReturnConfirmDialogComponent;
  isShowFileManagement: boolean = false;
  isHeaderLoading: boolean = false;
  isDetailLoading: boolean = false;
  isEditing: boolean = false;
  isConfirmed: boolean = false;
  isApplyBtnDisabled: boolean = false;
  isReplyBtnDisabled: boolean = false;
  canReUploadFile: boolean = false;
  checkedConfirmStatus: string = 'P';

  @Input() canEditTable: boolean = true;
  @Input() canUploadDoc: boolean = true;
  @Input() canConfirm: boolean = true;

  headerTableValue: SearchTaskDocHeaderResponse[] = [];
  detailTableValue: SearchTaskDocDetailResponse[] = [];
  selectedRow?: SearchTaskDocHeaderResponse;
  headerTableColumns: DateTableColumn[] = [];
  detailTableColumns: DateTableColumn[] = [];

  taskOptions: LaasOption[] = [];
  docTypeOptions: LaasOption[] = [];
  limitDocTypes: string[] = [];
  isReplyDialogVisible: boolean = false;
  isApplyDialogVisible: boolean = false;
  isReturnApplyShow: boolean = false;
  isReturnReplyShow: boolean = false;
  applyForm!: FormGroup;
  replyForm!: FormGroup;

  pageInfo: PageInfo;
  sortInfo: { property: string, direction: number } | null;

  clonedHeaderRowDatas: { [s: string]: SearchTaskDocHeaderResponse; } = {};

  readonly editPermissionCode: PermissionConstants = PermissionConstants.EditFrontLineDocument;
  readonly BtnApplyFrontLineDocReturn: PermissionConstants = PermissionConstants.BtnApplyFrontLineDocReturn; // 申請
  readonly BtnReplyFrontLineDocReturn: PermissionConstants = PermissionConstants.BtnReplyFrontLineDocReturn; // 回覆

  constructor(injector: Injector,
    private commonDataService: CommonDataService,
    private frontlineDocumentService: FrontlineDocumentService,
    private bookingService: BookingService,
    private DOService: DeliveryOrderService,
    private fb: FormBuilder
  ) {
    super(injector);
    this.pageInfo = {
      pageSize: 5,
      pageIndex: 0,
      totalRecords: 0,
      totalPages: 0,
    };
    this.sortInfo = null;

    this.headerTableColumns = this.headerTableColumnsDate;
    this.detailTableColumns = this.detailTableColumnsDate;
  }

  ngOnInit(): Promise<void> {
    this.initReturnDialogForms();
    return super.ngOnInit();
  }

  headerTableColumnsDate: DateTableColumn[] = [
    { field: 'doNo', header: 'DoNo', sort: true },
    { field: 'taskList', header: 'TaskDoc.Task', sort: false },
  ];

    detailTableColumnsDate: DateTableColumn[] = [
      { field: 'documentTask', header: 'TaskDoc.Task', sort: false },
      { field: 'status', header: 'TaskDoc.DetailTable.Status', sort: false },
      { field: 'docType', header: 'TaskDoc.DetailTable.DocType', sort: false },
      { field: 'fileName', header: 'TaskDoc.DetailTable.FileName', sort: false },
      { field: 'updateUser', header: 'TaskDoc.DetailTable.UpdateUser', sort: true },
      { field: 'updateDt', header: 'TaskDoc.DetailTable.UpdateDt', sort: true }
    ];


  resetComponent(doNoList: string[]){
    //取回該TaskClassName，所有在Logistics.Task的選項 註記
    this.frontlineDocumentService.getTaskOptions(this.laasSetting.language, this.fileCategory.taskClassName).subscribe({
      next: result => {
        this.taskOptions = [...result].map<LaasOption>((x: TaskListOptions) => {
          return {
            label: `${x.taskCode} - ${x.taskMean}`,
            value: x.taskCode
          };
        });
      }
    })


    //所有文件類型
    this.commonDataService.getCodeConverter(this.laasSetting.language, "DropdownList", this.fileCategory.codeConverterType).subscribe({
      next: (results: CodeConverter[]) => {
        this.docTypeOptions = results.map(x => {
          return {
            label: x.codeDesc,
            value: x.codeKey
          } as LaasOption
        });
      }
    });


    if(this.canEditTable){
      this.canEditTable = this.permissionCodes.includes(this.editPermissionCode);
    }
    this.isReturnApplyShow = this.permissionCodes.includes(this.BtnApplyFrontLineDocReturn);
    this.isReturnReplyShow = this.permissionCodes.includes(this.BtnReplyFrontLineDocReturn);

    this.headerTableValue = [];
    this.detailTableValue = [];
    // 把編輯中的key清除，就不會有編輯一直開著的問題
    this.headerTable.editingRowKeys = {};
    this.isEditing = false;
    this.searchTaskDocHeader(doNoList, this.fileCategory.taskClassName);
    this.isConfirmed = false;
    this.checkConfirmStatus();
  }

  async setPageSize(event: any): Promise<void> {
    this.pageInfo.pageSize = event.rows;
  }

  tablePageChange(event: any): void {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
  }

  tableSort(event: any): void {
    this.sortInfo = { property: event.field, direction: event.order };
  }

  openFileManagement(event: Event): void {
    this.isShowFileManagement = true;
  }

  onShowFileManagement(event: Event): void {
    this.fileManagement.resetComponent();
  }

  //比對出此DO的註記
  searchTaskDocHeader(doNoList: string[], taskClassName: string) {
    this.isHeaderLoading = true;
    let req = new SearchTaskDocHeaderRequest();
    req.doNoList = doNoList;
    req.taskClassName = taskClassName;
    this.frontlineDocumentService.searchHeader(req).subscribe({
      next: result => {
        this.headerTableValue = result;
        // flatMap的效果，把所有docTypeList map 成一個陣列
        this.limitDocTypes = result.map(value => value.docTypeList).reduce((prev, curr) => prev.concat(curr), []);
        // 助理附件如果選的do沒有註記，要把選項都關掉，打一個不存在的字串讓他比對不到
        if (this.limitDocTypes.length == 0) {
          this.limitDocTypes.push("empty");
        }
        this.searchTaskDocDetail(result[0]);
        this.selectedRow = result[0];
        this.checkConfirmStatus();
        this.isHeaderLoading = false;
      }
    })
  }
  //比對出此DO的註記
  searchTaskDocDetail(rowData: SearchTaskDocHeaderResponse) {
    this.isDetailLoading = true;
    rowData.lockHeaderType = this.fileCategory.doLockHeader;
    this.frontlineDocumentService.searchDetail(rowData).subscribe({
      next: result => {
        console.log(result);
        this.detailTableValue = result;

        this.isDetailLoading = false;
      }
    })
  }

  onRowEditInit(rowData: SearchTaskDocHeaderResponse) {
    this.clonedHeaderRowDatas[rowData.doNo] = {...rowData};
    this.isEditing = true;
  }

  async onRowEditSave(rowData: SearchTaskDocHeaderResponse) {
    this.isEditing = false;
    await this.doChangeTask(rowData);
    this.toastService.success(this.translateService.instant('TaskDoc.ChangeTask.Success'));
    this.searchTaskDocHeader(this.referenceKeys, this.fileCategory.taskClassName);
  }

  onRowEditCancel(rowData: SearchTaskDocHeaderResponse, index: number) {
    this.headerTableValue[index] = this.clonedHeaderRowDatas[rowData.doNo];
    delete this.clonedHeaderRowDatas[rowData.doNo];
    this.isEditing = false;
  }

  onRowSelect(event: any) {
    if (this.selectedRow && !this.isEditing) {
      this.searchTaskDocDetail(this.selectedRow)
    }
  }

  downloadFile(event: any, rowData: any) {
    const searchObj = {
      sn: rowData.docId,
      version: rowData.version,
    };
    this.DOService.downloadFile(searchObj).subscribe((x) => {
      const blob = new Blob([x], { type: 'application/octet-stream' }); // application後面接下載的副檔名

      let downloadURL = window.URL.createObjectURL(blob);
      let link = document.createElement('a');
      link.href = downloadURL;
      link.download = `${this.selectedRow?.doNo}_${rowData.fileName}`; // 瀏覽器下載時的檔案名稱
      link.click();
    });
  }

  async doChangeTask(rowData: SearchTaskDocHeaderResponse) {
    this.isHeaderLoading = true;
    let request = new TaskDocChangeTaskRequest();
    request.doNo = rowData.doNo;
    request.changeTaskList = rowData.taskList;
    request.changeUser = this.userProfile.userName;
    request.taskClassName = this.fileCategory.taskClassName;
    request.doLockHeader = this.fileCategory.doLockHeader;

    await this.frontlineDocumentService.changeTask(request).toPromise();
    this.isHeaderLoading = false;
  }

  doConfirm() {
    this.confirmationService.confirm({
      message: (this.fileCategory == FileCategory.FrontLine)? this.translateService.instant('TaskDoc.Confirmation.MessageForFrontLineDoc') :  this.translateService.instant('TaskDoc.Confirmation.MessageForCustomerLabel'),
      header: this.translateService.instant('TaskDoc.Confirmation.Header'),
      icon: 'pi pi-info-circle',
      accept: async () => {
        let request = new TaskDocConfirmRequest();
        request.doNoList = this.referenceKeys;
        request.confirmUser = this.userProfile.userName;
        request.doLockHeader =  this.fileCategory.doLockHeader;
        request.taskClassName = this.fileCategory.taskClassName;
        request.isReturn = this.canReUploadFile;

        this.frontlineDocumentService.confirmDo(request).subscribe({
          next: () => {
            this.toastService.success(this.translateService.instant('TaskDoc.Confirmation.Success'));
            this.checkConfirmStatus();
          },
          error: (err: any) => {
            this.toastErrorMessage(err.error);
          }
        })

      },
    });

  }

  checkConfirmStatus() {
    for (const doNo of this.referenceKeys) {
      this.frontlineDocumentService.checkConfirmStatus(doNo, this.fileCategory.doLockHeader, this.fileCategory.taskClassName).subscribe({
        next: result => {
          this.checkedConfirmStatus = result.status;
          console.log(`Checked status for ${doNo}: ${this.checkedConfirmStatus}`);
          if (result.status == "F") {
            this.isConfirmed = true;
            this.canReUploadFile = false;
          } else if (result.status == "RU" || result.status == "SP") {
            // 狀態為 RU, SP 代表可以重新上傳檔案
            this.canReUploadFile = true;
          }
        }
      })
    }
  }

  isDocUploadDisabled(): boolean {
    const statusAllowed = ['RU', '0', 'SP', 'P'].includes(this.checkedConfirmStatus);

    return !statusAllowed || (this.isEditing || this.isConfirmed || !this.canUploadDoc);
  }

  isDocConfirmDisabled(): boolean {
    // 確認要用有沒有上傳檔案去判斷，不能用狀態(因為有SP)
    const confirmAllowed = this.detailTableValue.length > 0 && this.detailTableValue.every(item => !!item.docId)

    return !confirmAllowed || (this.isEditing || this.isConfirmed || !this.canUploadDoc);
  }

  onHideFileManagement(event: Event) {
    if (!isNullOrEmpty(this.selectedRow) && this.selectedRow) {
      this.searchTaskDocDetail(this.selectedRow);
    }
  }

  //關掉時如果全是P提醒可按確認
  doRemindConfirm() {
    let confirmStatus = true;
    if (this.canConfirm) {
      const observables = this.referenceKeys.map(doNo => this.frontlineDocumentService.checkConfirmStatus(doNo, this.fileCategory.doLockHeader, this.fileCategory.taskClassName));

      forkJoin(observables).subscribe(results => {
        for (const result of results) {
          console.log(result);
          if (result.status !== "P") {
            confirmStatus = false;
          }
        }

        if (confirmStatus) {
          this.toastService.info(this.translateService.instant('TaskDoc.RemindMsg'), true);
        }
      });
    }
  }

  clickRow(rowData: any) {
    this.selectedRow = rowData;
  }

  searchTaskDocHeaderByBookingNo(doNoList: string[], taskClassName: string) {
    this.isHeaderLoading = true;
    let req = new SearchTaskDocHeaderRequest();
    req.taskClassName = taskClassName;
    if (this.callingFunction == 'bookingSearch') {
      req.bookingNo = this.referenceKeys;
    }
    this.frontlineDocumentService.searchHeaderByBookingNo(req).subscribe({
      next: result => {
        this.headerTableValue = result;
        // flatMap的效果，把所有docTypeList map 成一個陣列
        this.limitDocTypes = result.map(value => value.docTypeList).reduce((prev, curr) => prev.concat(curr), []);
        // 助理附件如果選的do沒有註記，要把選項都關掉，打一個不存在的字串讓他比對不到
        if (this.limitDocTypes.length == 0) {
          this.limitDocTypes.push("empty");
        }
        this.searchTaskDocDetail(result[0]);
        this.selectedRow = result[0];
        this.isHeaderLoading = false;
      }
    })
  }

  doApplyFrontLineDocReturn() {
    if (!this.selectedRow) {
      this.toastService.warn('請先選擇一筆資料');
      return;
    }
    // this.isApplyBtnDisabled = true;
    this.isHeaderLoading = true;

    // 準備請求數據
    const request: FrontLineDocReturnRequest = new FrontLineDocReturnRequest();
    request.doNo = this.selectedRow.doNo || '';
    request.docTypes = this.getFrontLineDocTypes();
    request.doLockHeader = this.fileCategory.doLockHeader;
    request.applyUser = this.userProfile.loginAccount;

    this.frontlineDocumentService
      .applyFrontLineDocReturn(request)
      .subscribe((response) => {
        // 未通過驗證 (狀態不符或其他錯誤)
        if (!response.isValidate) {
          this.toastService.warn(response.message || '不符合退回資格');
          this.isHeaderLoading = false;
          return;
        }

        // 通過驗證且無需Booking (可直接退回)
        if (response.isValidate && !response.isBooking) {
          this.toastService.success('退回成功');
          this.isHeaderLoading = false;
          return;
        }

        // 通過驗證但已有Booking (需要輸入退回原因)
        if (response.isValidate && response.isBooking && response.isReasonRequired) {
          // Update dialog to show input field
          this.openApplyDialog(request);
        }
      });
  }

  /**
   * 處理退回回覆流程
   */
  doReplyFrontLineDocReturn() {
    const request: FrontLineDocReturnConfirmRequest = new FrontLineDocReturnConfirmRequest();
    request.doNo = this.selectedRow?.doNo || '';
    request.docTypes = this.getFrontLineDocTypes();
    request.doLockHeader = this.fileCategory.doLockHeader;
    request.applyUser = this.userProfile.loginAccount;
    this.isHeaderLoading = true;

    this.openReplyDialog(request);
  }

  openApplyDialog(request: FrontLineDocReturnRequest) {
    this.isHeaderLoading = false;
    setTimeout(() => {
      this.applyDialog.title = "申請退回";
      this.applyDialog.showInput = true;
      this.applyDialog.showRadio = false;
      this.applyDialog.isVisible = true;

      this.applyDialog.onConfirm.pipe(take(1)).subscribe((reason) => {
        this.isHeaderLoading = true;

        if (!reason || reason.reason === '') {
          this.toastService.warn('請輸入退回原因');
          return;
        }

        request.applyReason = reason.reason;

        this.frontlineDocumentService.applyFrontLineDocReturn(request).subscribe((secondResponse) => {
          if (secondResponse.isValidate) {
            this.toastService.success(secondResponse.message || '申請提交成功');
          } else {
            this.toastService.warn(secondResponse.message || '申請提交失敗');
          }
          this.applyDialog.isVisible = false;
          this.isHeaderLoading = false;
        });
      });
    }, 0);
  }


  openReplyDialog(request: FrontLineDocReturnConfirmRequest) {
    this.isHeaderLoading = false;
    setTimeout(() => {
      this.replyDialog.title = "回覆退回申請";
      this.replyDialog.showInput = false;
      this.replyDialog.showRadio = true;
      this.replyDialog.isVisible = true;

      this.replyDialog.onCancel.pipe(take(1)).subscribe(() => {
        // this.isReplyBtnDisabled = false;
      });
      this.replyDialog.onConfirm.pipe(take(1)).subscribe((reason) => {
        this.isHeaderLoading = true;

        if (this.replyDialog.showInput && (!reason || reason.reason === '')) {
          this.toastService.warn('請輸入拒絕原因');
          return;
        }

        const decision = this.replyDialog.form.get('decision')?.value;
        request.isAccept = decision === 'accept';
        request.rejectReason = reason.reason;

        this.frontlineDocumentService.replyFrontLineDocReturn(request).subscribe((response) => {
          if (response.isValidate) {
            this.toastService.success(response.message || '退回回覆已提交');
          } else {
            this.toastService.warn(response.message || '提交失敗');
          }
          this.replyDialog.isVisible = false;
          this.isHeaderLoading = false;
        });
      });
    }, 0);
  }

  initReturnDialogForms() {
    this.applyForm = this.fb.group({
      doNo: [''],
      docTypes: [[]],
      doLockHeader: [null],
      applyUser: [null],
      applyReason: [null],
    });

    this.replyForm = this.fb.group({
      doNo: [''],
      docTypes: [[]],
      doLockHeader: [null],
      applyUser: [null],
      isAccept: [true],
      rejectReason: [null],
    });
  }

  getFrontLineDocTypes(): string[] {
    if (!this.selectedRow) {
      return [];
    }

    return this.selectedRow.docTypeList || [];
  }
}
